/**
 *
 * Asynchronously loads the component for ErrorAlert
 *
 */

import loadable from "../../utils/loadable";

export default loadable(() => import("./index"));
